import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import { SCSGenericButton } from "app/modules/common/components/Buttons/SCSButtons";
import InfoPopoverHover from "app/modules/shared/components/InfoPopoverHover";
import InfoPopoverButton from "app/modules/shared/components/InfoPopoverButton";

const BuscadorPreevCliente = ({
  traerDatosPreev,
  traerIdentificacion,
  validarIdentificacionCF,
  validado,
  limpiar,
  loading,
  loadingPreevaluar,
  idGrupo,
}) => {
  const history = useHistory();
  const [identificacion, setIdentificacion] = useState();
  const [habilitado, setHabilitado] = useState(validado);
  const [datos, setDatos] = useState({});

  const handleIdentificacion = (e) => {
    //console.log("cambia");
    //handleLimpiar(e.target.value);
    setIdentificacion(e.target.value);
  };
  const handlesetDatos = (e) => {
    switch (e.target.id) {
      case "cedula":
        setDatos({ ...datos, identificacion: e.target.value });
        break;
      case "codDactilar":
        setDatos({ ...datos, codDactilar: e.target.value });
        break;
      case "mailCliente":
        setDatos({ ...datos, mailCliente: e.target.value });
        break;
      case "celularCliente":
        setDatos({ ...datos, celularCliente: e.target.value });
        break;
      default:
        break;
    }
  };
  const redirectHomePage = () => {
    history.push("/initialHome");
  };
  const handleLimpiar = (val) => {
    console.log(val);
    limpiar(val);
  };

  return (
    <>
      <Card
        className="buscador-container-preev"
        sx={{ backgroundColor: "#e9f0ffff" }}
      >
        <div /*className="buscador-cabecera-preev"*/>
          <h2>
            ¡Comencemos! Ten a la mano tu cédula y completa todos los campos
            obligatorios para que tu solicitud sea un éxito.
          </h2>
        </div>
        <Stack
          //direction={"row"}
          sx={{ marginTop: 1, marginBottom: 1 }}
          alignItems={"center"}
          justifyContent={"space-evenly"}
          direction={{ xs: "column", sm: "column", md: "row" }}
        >
          <img
            className="image-square"
            src={`/images/logo-preev-${idGrupo}.png`}
            alt="logo-credi"
            loading="lazy"
          />
          <Stack
            sx={{ marginTop: 1, marginBottom: 1 }}
            justifyContent="center"
            alignItems="flex-start"
            direction={{ xs: "column", sm: "column", md: "column" }}
            spacing={{ xs: 2, sm: 3, md: 3 }}
            useFlexGap
          >
            <TextField
              id="cedula"
              label="Cedula"
              size="large"
              variant="outlined"
              value={datos.identificacion}
              onChange={handlesetDatos}
              InputProps={{
                inputProps: {
                  size: "28",
                },
              }}
            />
            <Stack direction={"row"} spacing={1} alignItems={"center"}>
              <TextField
                id="codDactilar"
                label="Codigo Dactilar"
                size="large"
                variant="outlined"
                value={datos.codDactilar}
                onChange={handlesetDatos}
                InputProps={{
                  inputProps: {
                    size: "28",
                  },
                }}
              />
              <InfoPopoverButton nombre={"CD"} color={"#000000"}>
                <Stack
                  alignItems={"center"}
                  justifyContent={"center"}
                  direction={"column"}
                  mb={2}
                >
                  <Box sx={{ maxWidth: 350, padding: 1 }}>
                    <Typography sx={{ textAlign: "justify" }}>
                      El código dactilar se encuentra en el reverso de la cédula
                      de identidad, en la parte superior derecha, como se
                      muestra continuación. Esta compuesta por 10 dígitos en
                      donde el primero y el sexto son letras.
                    </Typography>
                    <Box
                      component="img"
                      src={`/images/dactilar.png`}
                      alt="logo-credi"
                      loading="lazy"
                      sx={{ width: "100%", maxWidth: 300, display: "block", mx: "auto", p: 1 }}
                    />
                  </Box>
                </Stack>
              </InfoPopoverButton>
            </Stack>
            <TextField
              id="mailCliente"
              label="Correo Electronico"
              size="large"
              variant="outlined"
              value={datos.mailCliente}
              onChange={handlesetDatos}
              InputProps={{
                inputProps: {
                  size: "28",
                },
              }}
            />
            <TextField
              id="celularCliente"
              label="Celular"
              size="large"
              variant="outlined"
              value={datos.celularCliente}
              onChange={handlesetDatos}
              InputProps={{
                inputProps: {
                  size: "28",
                },
              }}
            />
          </Stack>
        </Stack>
        {/* <div className="buscador-body-preev"> */}
        <Stack
          sx={{ marginTop: 3 }}
          direction={{ xs: "column", sm: "column", md: "row" }}
          spacing={{ xs: 2, sm: 3, md: 3 }}
          justifyContent={"flex-end"}
        >
          {/* <SCSGenericButton
            loading={loading}
            //loadingPosition="end"
            variant="contained"
            onClick={validarIdentificacionCF(datos.identificacion)}
            //disabled={displayButtonCargar}
            titulo={"Terminos y Condiciones"}
          /> */}

          <SCSGenericButton
            //disabled={!validado}
            loading={loadingPreevaluar}
            //loadingPosition="end"
            variant="contained"
            onClick={traerDatosPreev(datos)}
            //disabled={displayButtonCargar}
            titulo={"Continuar"}
            size={20}
          />

          <SCSGenericButton
            variant="contained"
            onClick={redirectHomePage}
            titulo={"Cancelar"}
            size={20}
          />
        </Stack>
        {/* </div> */}
      </Card>
    </>
  );
};

export default BuscadorPreevCliente;
